import { Radio, RadioGroup, Stack } from "@chakra-ui/react";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { IoIosArrowDown as DownArrow, IoIosArrowUp as UpArrow } from "react-icons/io";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import AddressField from "../../../components/AddDataComponents/AddressField";
import EmailField from "../../../components/AddDataComponents/EmailField";
import LinkField from "../../../components/AddDataComponents/LinkField";
import PhoneField from "../../../components/AddDataComponents/PhoneField";
import RelationshipField from "../../../components/AddDataComponents/RelationshipField";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import Loader from "../../../components/Loader";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";

const AddContactData = ({ setAddContactData, showModal, onClose, onSetError, handleSubmit, addContactData, onSetAddContactData, phones, onSetPhones, emails, onSetEmails, addresses, onSetAddresses, onSetRelations, relations, links, onSetLinks, error, disable, }) => {
  const [config] = useAuth();
  const [loading, setLoading] = useState(true);
  const [showAboutData, setShowAboutData] = useState(true);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [contactOptions, setContactOptions] = useState([]);
  const [leadTypeOptions, setLeadTypeOptions] = useState([]);
  const [contactTagOptions, setContactTagOptions] = useState([]);
  const [leadSourcesOptions, setLeadSourcesOptions] = useState([]);
  const [showAdditionalData, setShowAdditionalData] = useState(true);

  const fetchContactTags = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/get-datalisting?list=contact_tags`, config)
      .then((res) => {
        const value = res?.data?.data?.contact_tags;
        setContactTagOptions(value?.map((el) => ({ value: el?.id, label: el?.tag_name })));
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  const fetchLeadSources = () => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=lead_sources`, config)
      .then((res) => {
        const value = res?.data?.data?.lead_sources;
        setLeadSourcesOptions(value?.map((el) => ({ value: el?.id, label: el?.name, category: el?.category })));
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    if (addContactData?.leadSourceType === "list") {
      setLeadTypeOptions(leadSourcesOptions);
    } else {
      setLeadTypeOptions(contactOptions);
    }
  }, [addContactData?.leadSourceType, contactOptions, leadSourcesOptions]);

  const fetchContactSuggestions = (inputValue) => {
    if (inputValue !== "") {
      const encodedInputValue = encodeURIComponent(inputValue);
      axios
        .get(`${BASE_URL}/get-datalisting?list=contacts&search=${encodedInputValue}`, config)
        .then((res) => {
          const value = res?.data?.data?.contact_list;
          setContactOptions(
            value?.map((data) => ({
              value: data?.id,
              label: `${data?.first_name} ${data?.last_name}`,
            }))
          );
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        });
    } else {
      setContactOptions([]);
    }
  };

  const fetchSuggestions = (inputValue) => {
    if (inputValue !== "") {
      const encodedInputValue = encodeURIComponent(inputValue);
      axios
        .get(`${BASE_URL}/get-datalisting?list=companies&search=${encodedInputValue}`, config)
        .then((res) => {
          const value = res?.data?.data?.company_list;
          setCompanyOptions(
            value?.map((data) => ({
              value: data.id,
              label: data.company_name,
            }))
          );
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        });
    } else {
      setCompanyOptions([]);
      onSetAddContactData({ ...addContactData, company_name: "", company: "" });
    }
  };


  useEffect(() => {
    if (showModal) {
      fetchContactTags();
      fetchLeadSources();
    }
  }, [showModal]);

  const handleChange = (value, name) => {
    const allowedPattern = /^[\s\S]*$/;

    if (name === "firstName" || name === "lastName" || name === "title") {
      if (allowedPattern.test(value) || value === "") {
        onSetAddContactData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      onSetAddContactData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="body-N">
          <label className="container head-5 dark-M">
            <p>Mark as Lead</p>
            <input
              type="checkbox"
              checked={addContactData?.isLead}
              onChange={(e) => {
                handleChange(e.target.checked, "isLead");
              }}
            />
            <span className="checkmark"></span>
          </label>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="flex gap-5 mt-6">
              <div>
                <label className="dark-H head-4 mb-2 required:*:">
                  First Name<span className="red-D">*</span>
                </label>
                <input
                  className="body-N"
                  name="firstName"
                  type="text"
                  placeholder="Write First Name Here"
                  value={addContactData.firstName}
                  onChange={(e) => {
                    onSetError({ ...error, first_name: "" });
                    handleChange(e.target.value, "firstName");
                  }}
                />
                {error?.first_name && <span className="body-S red-D">{error?.first_name}</span>}
              </div>

              <div>
                <label className="dark-H head-4 mb-2 ">
                  Last Name<span className="red-D">*</span>
                </label>
                <input
                  className="body-N"
                  name="lastName"
                  type="text"
                  placeholder="Write Last Name Here"
                  value={addContactData.lastName}
                  onChange={(e) => {
                    onSetError({ ...error, last_name: "" });
                    handleChange(e.target.value, "lastName");
                  }}
                />
                {error?.last_name && <span className="body-S red-D">{error?.last_name}</span>}
              </div>
            </div>


            <div className="flex gap-5 mt-6">
              <div className="w-[50%]">
                <label className="dark-H head-4 ">Company Name</label>

                <div className="mt-1.5 flex-1 relative">
                  <SearchDropdown
                    isTop={false}
                    placeholder="Search Company Here"
                    text={addContactData?.company_name || ""}
                    options={companyOptions}
                    fetchSuggestions={fetchSuggestions}
                    onSetOptions={(value) => setCompanyOptions(value)}
                    onChange={(e) => {
                      const value = e.target.value;
                      onSetAddContactData((prev) => {
                        const shouldClearId = value !== prev.company_name;

                        return {
                          ...prev,
                          company_name: value,
                          company: value,
                          ...(shouldClearId && { company_id: "" }),
                        };
                      });
                    }}

                    handleSelect={(option) => {
                      console.log("Selected:", option);

                      onSetError((prev) => ({
                        ...prev,
                        company: "",
                      }));

                      onSetAddContactData((prev) => ({
                        ...prev,

                        company_id: option?.value || "",
                        company_name: option?.label || "",

                        company: "",
                      }));

                      setCompanyOptions([]);
                    }}
                  />

                  {/* Clear Button */}
                  {addContactData?.company_name && (
                    <button
                      type="button"
                      onClick={() => {
                        onSetAddContactData((prev) => ({
                          ...prev,
                          company_id: "",
                          company_name: "",
                          company: "",
                        }));
                        setCompanyOptions([]);
                      }}
                      className="absolute right-2 top-2 text-gray-500 hover:text-black"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>

              <div className="w-[50%]">
                <label className="dark-H head-4 mb-2">Title</label>
                <input
                  className="body-N"
                  name="title"
                  type="text"
                  placeholder="Write Title Here"
                  value={addContactData.title}
                  onChange={(e) => {
                    handleChange(e.target.value, "title");
                  }}
                />
              </div>
            </div>


            <PhoneField phones={phones} onSetPhones={onSetPhones} />

            <EmailField emails={emails} onSetEmails={onSetEmails} />

            <hr className="mt-6" />

            <div className="flex items-center gap-2 mt-6" role="button" onClick={() => setShowAdditionalData(!showAdditionalData)}>
              <p className="head-4 dark-H">Additional Contact Information</p> {showAdditionalData ? <UpArrow /> : <DownArrow />}
            </div>

            {showAdditionalData && (
              <>
                <AddressField isApt={false} addresses={addresses} onSetAddresses={onSetAddresses} />

                <div className="mt-6">
                  <label className="dark-H head-4">Tags</label>
                  <div className="mt-2">
                    <Select
                      isMulti
                      className="service-area body-N"
                      placeholder="Add Tags Here"
                      options={contactTagOptions}
                      value={contactTagOptions?.filter((el) => addContactData?.tags?.includes(el?.value))}
                      onChange={(options) => {
                        const values = options?.map((el) => el.value);
                        handleChange(values, "tags");
                      }}
                    />
                  </div>
                </div>

                <div className="mt-6">
                  <p className="head-4 dark-H mb-3">Lead Source Type</p>

                  <RadioGroup
                    onChange={(value) => {
                      setLeadTypeOptions(contactOptions);
                      onSetAddContactData({ ...addContactData, leadSourceType: value, selectedLeadData: "" });
                    }}
                    value={addContactData?.leadSourceType}
                  >
                    <Stack direction="row" gap={5}>
                      <Radio value="list">Select From List</Radio>
                      <Radio value="contact">Select From Contacts</Radio>
                    </Stack>
                  </RadioGroup>
                </div>

                {addContactData?.leadSourceType !== "" && (
                  <div className="mt-6">
                    {addContactData?.leadSourceType === "list" ? (
                      <Select
                        name="selectedLeadData"
                        options={leadTypeOptions}
                        placeholder={`${addContactData?.leadSourceType === "list" ? "Select Lead" : "Select Contact"}`}
                        value={leadTypeOptions?.find((el) => el?.value === addContactData?.selectedLeadData)}
                        onChange={(option) => {
                          handleChange(option.value, "selectedLeadData");
                        }}
                      />
                    ) : (
                      <div className="flex-1">
                        <SearchDropdown
                          isTop={false}
                          placeholder="Search Contact Here"
                          text={addContactData?.contact_name}
                          options={contactOptions}
                          fetchSuggestions={fetchContactSuggestions}
                          onSetOptions={(value) => setContactOptions(value)}
                          handleSelect={(option) => {
                            onSetAddContactData({ ...addContactData, contact_name: option?.label, selectedLeadData: option?.value });
                            setContactOptions([]);
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            <hr className="mt-6" />

            <div className="flex items-center gap-2 mt-6" role="button" onClick={() => setShowAboutData(!showAboutData)}>
              <p className="head-4 dark-H">About</p> {showAboutData ? <UpArrow /> : <DownArrow />}
            </div>

            {showAboutData && (
              <>
                <RelationshipField relations={relations} onSetRelations={onSetRelations} />

                <LinkField links={links} onSetLinks={onSetLinks} />

                <div className="flex gap-2 mt-6">
                  <div>
                    <label className="dark-H head-4">First Deal Anniversary</label>
                    <DatePicker
                      className="body-N"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      maxDate={new Date()}
                      selected={
                        addContactData.first_deal_anniversary
                          ? moment.tz(addContactData.first_deal_anniversary, 'America/New_York').toDate()
                          : null
                      }
                      onChange={(date) => {
                        const newDate = date ? moment.tz(date, 'America/New_York').toDate() : null;
                        onSetError({ ...error, first_deal_anniversary: "" });
                        handleChange(newDate, "first_deal_anniversary");
                      }}
                    />


                    {error?.first_deal_anniversary && <span className="body-S red-D">{error?.first_deal_anniversary}</span>}
                  </div>

                  <div>
                    <label className="dark-H head-4">Birthday</label>
                    <DatePicker
                      className="body-N"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      maxDate={new Date()}
                      selected={addContactData.birthday}
                      onChange={(date) => {
                        onSetError({ ...error, birthday: "" });
                        handleChange(date, "birthday");
                      }}
                    />
                    {error?.birthday && <span className="body-S red-D">{error?.birthday}</span>}
                  </div>

                  <div>
                    <label className="dark-H head-4">Tax Record Letter Sent</label>
                    <DatePicker
                      className="body-N"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      selected={addContactData.tax_record_sent}
                      onChange={(date) => {
                        onSetError({ ...error, tax_record_sent: "" });
                        handleChange(date, "tax_record_sent");
                      }}
                    />
                    {error?.tax_record_sent && <span className="body-S red-D">{error?.tax_record_sent}</span>}
                  </div>
                </div>

                <div className="mt-6">
                  <label className="dark-H head-4 mb-2">Comments</label>
                  <textarea
                    rows={3}
                    className="body-N"
                    name="title"
                    type="text"
                    placeholder="Write Here..."
                    value={addContactData.description}
                    onChange={(e) => {
                      handleChange(e.target.value, "description");
                    }}
                  />
                </div>
              </>
            )}

            <hr className="mt-6" />

            <div className="mt-6">
              <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
                Save
              </button>
              <button type="button" onClick={onClose} className="green-H ml-5">
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default AddContactData;
